import { PropType } from 'vue'
import { getCourse_getCourse_GetCourseOutput_course } from '__generated__/getCourse'
import { getHolesForCourse_listHoles_ListHolesOutput_holes } from '__generated__/getHolesForCourse'

export const props = {
  courseData: {
    type: Object as PropType<getCourse_getCourse_GetCourseOutput_course>,
    default: {}
  },
  currentURL: {
    type: String,
    default: ''
  },
  holesData: {
    type: Object as PropType<getHolesForCourse_listHoles_ListHolesOutput_holes>,
    default: {}
  },
  slug: {
    type: String,
    default: ''
  }
}
